import {
    USER_ENTITY_ASSIGNMENTS_SET,
    USER_ENTITY_ASSIGNMENTS_MERGE
} from './constants';

import {
    SetUserEntityAssignmentsAction,
    MergeUserEntityAssignmentsAction,
    UserEntityAssignment,
    EntityGroupedUserAssignment
} from './types';

type Data = {
    email: string;
    jobType: string;
    entityId: number;
}[];

export function setUserEntityAssignments(
    data: UserEntityAssignment[]
): SetUserEntityAssignmentsAction {
    return {
        type: USER_ENTITY_ASSIGNMENTS_SET,
        payload: data
    };
}

export function mergeUserEntityAssignments(
    data: EntityGroupedUserAssignment[]
): MergeUserEntityAssignmentsAction {
    return {
        type: USER_ENTITY_ASSIGNMENTS_MERGE,
        payload: data
    };
}
